import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowAccount() {
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    rpc.register(RegionShared.Client.Events.Account.MainMenuShow, () => {
      setIsShow(true);
    });

    return () => {
      rpc.unregister(RegionShared.Client.Events.Account.MainMenuShow);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Client.Events.Account.MainMenuHide, () => {
      setIsShow(false);
    });

    return () => {
      rpc.unregister(RegionShared.Client.Events.Account.MainMenuHide);
    };
  }, []);

  return { isShow };
}
